import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationCommonEn from './translations/en/common.json'
import translationLoginEn from './translations/en/modules/auth.json'
import translationMenuEn from './translations/en/modules/menu.json'
import translationUsersEn from './translations/en/modules/users.json'
import translationParticipantsEn from './translations/en/modules/participants.json'
import translationDevicesEn from './translations/en/modules/devices.json'
import translationProgramsEn from './translations/en/modules/programs.json'
import translationTeamsEn from './translations/en/modules/teams.json'
import translationReportsEn from './translations/en/modules/reports.json'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
      common: translationCommonEn,
      auth: translationLoginEn,
      menu: translationMenuEn,
      users: translationUsersEn,
      participants: translationParticipantsEn,
      devices: translationDevicesEn,
      programs: translationProgramsEn,
      teams: translationTeamsEn,
      reports: translationReportsEn
  },
  fr: {
    translation: {
      "Welcome to React": "Bienvenue à React et react-i18next"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    defaultNS:'common',
     // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
